/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import {
  Dashboard, Person, Store, ShoppingCart, ListAlt, MenuBook,
} from '@mui/icons-material';
import { ItemModel } from '../../../pages/models';

const iconSx = {
  fontSize: '35px',
};
const Options = [{
  name: 'Solicitações',
  router: 'Dash',
  icon: <Dashboard sx={iconSx} />,
  id: 0,
},
{
  name: 'Cadastro',
  router: 'Cadastro',
  icon: <Person sx={iconSx} />,
  id: 1,
}];

export default Options;
